'use client';
import useNetworks from '#/data/useNetworks';
import useWatcherNetworks from '#/data/useWatcherNetworks';
import { ReactNode, useMemo } from 'react';
import { Button } from '../ui/button';
import {
  DropdownMenu,
  DropdownMenuCheckboxItem,
  DropdownMenuContent,
  DropdownMenuSeparator,
  DropdownMenuTrigger,
} from '../ui/dropdown-menu';
import { NetworkAvatar } from './network-avatar';

interface Props {
  placeholder?: ReactNode;
  value?: string[];
  onValueChange?(value: string[]): void;
}
export function WatcherNetworkSelectMultiple({
  placeholder,
  value,
  onValueChange,
  ...props
}: Props) {
  const { data, isLoading } = useNetworks();
  const { data: watcherNetworksData, isLoading: isWatcherNetworksLoading } =
    useWatcherNetworks();
  const options = useMemo(() => {
    return data?.data.data && watcherNetworksData?.data.data
      ? watcherNetworksData.data.data?.map(({ symbol }) => {
          const target = data.data.data?.find(item => item.symbol === symbol);
          return {
            label: target ? (
              <dl className="flex items-center space-x-2">
                <dd>
                  <NetworkAvatar symbol={target.symbol} className="w-5 h-5" />
                </dd>
                <dt>
                  {target.name} ({symbol})
                </dt>
              </dl>
            ) : null,
            value: symbol,
          };
        }) ?? []
      : [];
  }, [data, watcherNetworksData]);
  return (
    <DropdownMenu>
      <DropdownMenuTrigger asChild>
        <Button variant="outline">Open</Button>
      </DropdownMenuTrigger>
      <DropdownMenuContent className="w-56">
        {/* <DropdownMenuLabel>Appearance</DropdownMenuLabel> */}
        <DropdownMenuSeparator />
        {options.map((option, i) => (
          <DropdownMenuCheckboxItem
            key={i}
            checked={value?.includes(option.value)}
            onCheckedChange={checked =>
              onValueChange?.(
                checked
                  ? (value ?? [])?.concat(option.value)
                  : value?.filter(v => v != option.value) ?? []
              )
            }
          >
            {option.label}
          </DropdownMenuCheckboxItem>
        ))}
      </DropdownMenuContent>
    </DropdownMenu>
  );
}
